module.exports = __webpack_public_path__ + "static/media/summaryIcon.aca57769.svg";